import { useSettings } from '@backpackjs/storefront';

function SideCartUpsell() {
  const settings = useSettings();

  return settings?.sideCart?.rebuyWidgetId ? (
    <div className="rebuy-widget-overwritecss">
      <div data-rebuy-id={settings?.sideCart?.rebuyWidgetId} />
    </div>
  ) : null;
}

export default SideCartUpsell;
